import { Palette, TrendingUp, Code2, MessagesSquare, Clapperboard } from "lucide-react";
import { FadeUp, Eyebrow } from "./Reveal";
import { useLang } from "@/i18n";

const SERVICES = [
  { icon: Palette, tag: "01 / Foundation", tk: "s1_t", dk: "s1_d", accent: "#8B5CF6" },
  { icon: TrendingUp, tag: "02 / Acquisition", tk: "s2_t", dk: "s2_d", accent: "#F2C230" },
  { icon: Code2, tag: "03 / Digital", tk: "s3_t", dk: "s3_d", accent: "#8B5CF6" },
  { icon: MessagesSquare, tag: "04 / Engagement", tk: "s4_t", dk: "s4_d", accent: "#F2C230" },
  { icon: Clapperboard, tag: "05 / Creative", tk: "s5_t", dk: "s5_d", accent: "#8B5CF6" },
];

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="relative py-24 sm:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <FadeUp className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div>
            <Eyebrow>{t("services_eyebrow")}</Eyebrow>
            <h2 className="mt-4 font-serif-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#2B0A4E] leading-tight" data-testid="services-heading">
              {t("services_h1")} <span className="italic">{t("services_h2")}</span>
            </h2>
          </div>
          <p className="font-mono-label text-[11px] tracking-[0.2em] uppercase text-[#2B0A4E]/50">
            {t("services_note")}
          </p>
        </FadeUp>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <FadeUp
              key={s.tag}
              delay={0.08 * i}
              className={`${i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}`}
            >
              <div
                data-testid={`service-card-${s.tag.slice(0, 2)}`}
                className="group sketch-border bg-[#FFFFFF] p-7 sm:p-8 h-full flex flex-col hover:-translate-y-1.5 hover:shadow-[6px_6px_0_#2B0A4E] transition-[transform,box-shadow] duration-300"
              >
                <div
                  className="w-12 h-12 rounded-full flex items-center justify-center border border-[#2B0A4E]/20 group-hover:rotate-6 transition-transform duration-300"
                  style={{ backgroundColor: s.accent }}
                >
                  <s.icon size={22} strokeWidth={1.8} className={s.accent === "#F2C230" ? "text-[#2B0A4E]" : "text-[#FDFBF5]"} />
                </div>
                <p className="mt-6 font-mono-label text-[10px] tracking-[0.25em] uppercase text-[#2B0A4E]/50">
                  {s.tag}
                </p>
                <h3 className="mt-2 font-serif-display font-semibold text-xl sm:text-2xl text-[#2B0A4E]">
                  {t(s.tk)}
                </h3>
                <p className="mt-3 text-sm sm:text-base text-[#5E4783] leading-relaxed flex-1">
                  {t(s.dk)}
                </p>
              </div>
            </FadeUp>
          ))}

          <FadeUp delay={0.4}>
            <button
              data-testid="services-cta-card"
              onClick={() => window.__lenis?.scrollTo("#contact", { offset: -72 })}
              className="sketch-border w-full h-full min-h-[220px] bg-[#2B0A4E] text-[#FDFBF5] p-7 sm:p-8 flex flex-col justify-between text-left hover:bg-[#3E116B] hover:-translate-y-1.5 transition-[transform,background-color] duration-300"
            >
              <span className="font-mono-label text-[10px] tracking-[0.25em] uppercase text-[#F2C230]">
                {t("services_cta_top")}
              </span>
              <span className="font-serif-display italic text-2xl sm:text-3xl leading-snug">
                {t("services_cta_bottom")}
              </span>
            </button>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
